import httpClient, { API_URL } from '_metronic/api/httpclient';
import {
  ActKeyQueriesTypes, aggregateReportResponse, AllUsersQueriesTypes, IActKeyBody, IExportActKeys, IGetActKeys,
  IGetAdmin,
  IGetAdmins, IGetAllUsers, IGetAvatarChange,
  IGetBadge,
  IGetBadges,
  IGetBadgeTypes,
  IGetChallenge,
  IGetChallengeResult,
  IGetChallengeResults,
  IGetChallenges,
  IGetChapter,
  IGetChapters,
  IGetFAQ,
  IGetFAQs,
  IGetIAccesories,
  IGetIAccesory,
  IGetIAvatar,
  IGetIAvatars,
  IGetIFiche,
  IGetIFiches, IGetIGrades, IGetISubjectMenus,
  IGetLesson,
  IGetLessonCategories,
  IGetLessons,
  IGetLessonSection,
  IGetLessonSections,
  IGetLexique,
  IGetLexiques,
  IGetMindmap,
  IGetMindmaps,
  IGetQuestion,
  IGetQuestionReport,
  IGetQuestions,
  IGetQuizTypes,
  IGetReviews,
  IGetSettings,
  IGetSpecialObject,
  IGetSpecialObjects,
  IGetSpecialObjectTypes,
  IGetSubject,
  IGetSubjects,
  IGetSubscription,
  IGetSubscriptions,
  IGetUser, IGetUserActivity, IGetUserContent, IGetUserMetrics,
  IGetUsers,
  IGetUserSubscriptions,
  INewAccesory,
  INewAdmin,
  INewAvatar,
  INewBadge,
  INewChallengeResult,
  INewChapter,
  INewFAQ,
  INewIFiche,
  INewLesson,
  INEWLessonSection,
  INewLexique,
  INewMindmap,
  INewSpecialObject,
  INewSubscription, IPutAssignToUser, IPutGrade, IGetKeysProgress,
  NewSubjectStatus,
  ObjectTypes,
  TNewChallenge,
  TNewObject,
  TNewQuestion,
  TObject, userActivitiesParamsType, userContentsParamsType, userMetricParamsType, IGetLevelUp,
} from '_metronic/models';

import { getAuth } from '../../app/modules/auth';
import { IChapterFilter } from '_metronic/providers/list-view/models';
import subjects from "../../app/modules/shop/subjects";

export const CHAPTERS_URL = '/admin/chapter';
export const QUESTIONS_URL = '/admin/question';
export const CHALLENGES_URL = '/admin/challenge';
export const CHALLENGE_RESULTS_URL = '/admin/challenge-result';
export const FILES_URL = '/admin/file';
export const QUIZ_TYPES_URL = '/admin/question-type';
export const SETTINGS_URL = '/mobile/setting';
export const SUBJECTS_URL = (id?:number|string) => `/admin/content/grades/${id}/subjects`;
export const UPDATE_SUBJECT_STATUS = (id:number) => `/admin/content/subject/${id}/update-status`;
export const POST_CREATE_SUBJECT = (id:string) => `/admin/content/grades/${id}/subjects`
export const POST_CREATE_ACT_KEY = '/admin/access/active-key/collection/generate-keys'
export const POST_EXPORT_ACT_KEY = '/admin/access/active-key/key/export'
export const EXPORT_All_SELECTED_ACT_KEYS = '/admin/access/active-key/key/export-all'
export const PUT_CREATE_SUBJECT = (gId:string|number,sId: string|number) => `/admin/content/grades/${gId}/subjects/${sId}`
export const DELETE_SUBJECT =  (gradId?:number|string, subjectsId?:number|string) => `/admin/content/grades/${gradId}/subjects/${subjectsId}`
export const CATEGORY_LESSONS_URL = '/admin/lesson-category';
export const LESSONS_URL = '/admin/lesson';
export const LESSON_SECTIONS_URL = '/admin/lesson-section';
export const MINDMAP_URL = '/admin/mind-map';
export const LEXIQUES_URL = '/admin/lexique-content';
export const FICHES_URL = '/admin/fiches-content';
export const AVATARS_URL = '/admin/avatar';
export const ACCESSORIES_URL = '/admin/accessory';
export const SPECIAL_OBJECTS_URL = '/admin/special-object';
export const BADGES_URL = '/admin/badge';
export const SUBSCRIPTIONS_URL = '/admin/subscription';
export const FAQ_URL = '/admin/frequent-question';
export const UPLOAD_CENTER_URL = '/admin/upload-center';
export const ADMIN_URL = '/admin/admin';
export const USER_URL = '/admin/user';
export const REVIEW_URL = '/admin/review';
export const QUESTION_REPORT_URL = '/admin/report';
export const ABOUT_URL = '/admin/about-us';
export const GRADES_URL = '/admin/content/grades';
export const SUBJECT_MENUS = (id:number) => `/admin/content/subjects/${id}/menus`
export const UPDATE_SUBJECT_MENUS = (id:number, mId:number) => `/admin/content/subjects/${id}/menus/${mId}`
export const GET_ACT_KEYS = '/admin/access/active-key/key'
export const GET_ALL_USERS = 'admin/user-management/users'
export const UPDATE_GRADE =(id:string | number) => `/admin/content/grades/${id}`
export const GET_AGG_REPORTS =(id:string | number) => `/admin/report/aggregate/${id}/reports`
export const ASSIGN_TO_USER = (id:string | number) => `/admin/access/active-key/key/${id}/change-assigned-user`
export const USER_METRICS = '/admin/reporting/metrics/users'
export const USER_POPULARITY = '/admin/reporting/metrics/contents'
export const USER_ACTIVITY = '/admin/reporting/metrics/activities'
export const AVATAR_CHANGE = '/admin/animation/avatar-change'
export const FRIEND_DUEL = '/admin/animation/friend-duel'
export const RANDOM_DUEL = '/admin/animation/random-duel'
export const KEYS_PROGRESS = '/admin/animation/keys-progress'
export const LEVEL_UP = '/admin/animation/level-up'
export const AVATAR_CHANGE_AUDIO = '/admin/animation/avatar-change/audio'
export const AVATAR_CHANGE_BACKGROUND = '/admin/animation/avatar-change/background'
export const AVATAR_CHANGE_FOREGROUND = '/admin/animation/avatar-change/foreground'
export const POST_AVATAR_CHANGE = '/admin/animation/avatar-change/avatar'
export const POST_FRIEND_DUEL_AVATAR = '/admin/animation/friend-duel/avatar'
export const POST_FRIEND_DUEL_AUDIO = '/admin/animation/friend-duel/audio'
export const POST_FRIEND_DUEL_BACKGROUND = '/admin/animation/friend-duel/background'
export const POST_FRIEND_DUEL_FOREGROUND = '/admin/animation/friend-duel/foreground'
export const POST_RANDOM_DUEL_AVATAR = '/admin/animation/random-duel/avatar'
export const POST_RANDOM_DUEL_AUDIO = '/admin/animation/random-duel/audio'
export const POST_RANDOM_DUEL_BACKGROUND = '/admin/animation/random-duel/background'
export const POST_RANDOM_DUEL_FOREGROUND = '/admin/animation/random-duel/foreground'
export const POST_KEY_PROGRESS = '/admin/animation/keys-progress/animation'
export const POST_LEVEL_UP_AVATAR = '/admin/animation/level-up/avatar'
export const POST_LEVEL_UP_STARS = '/admin/animation/level-up/stars'
export const POST_LEVEL_UP_SOUNDS= '/admin/animation/level-up/sounds'
// questions
export async function getQuestions() {
  const {
    data: { result },
  } = await httpClient.get<IGetQuestions>(QUESTIONS_URL + '/list');
  return result;
}
export async function getQuestionsPage(page: number, search: string, chapterFilter: IChapterFilter | null) {
  let append
  if (chapterFilter) {
    append = `&quizable_type=App\\Models\\Challenge,App\\Models\\Chapter${chapterFilter?.grade !== -1 ? '&grade=' + chapterFilter?.grade : ''}${chapterFilter?.subject !== -1 ? '&subject=' + chapterFilter?.subject : ''}${chapterFilter?.chapter !== -1 ? '&chapter=' + chapterFilter?.chapter : ''}`;
  }
  else {
    append = `&quizable_type=App\\Models\\MediaLesson`
  }
  const {
    data: { result },
  } = await httpClient.get<IGetQuestions>(`${QUESTIONS_URL}/list?page=${page}${search ? '&search=' + search : ''}${append}`);
  return result;
}

export async function addQuestion(question: TNewQuestion) {
  const {
    data: { result },
  } = await httpClient.post<IGetQuestion>(QUESTIONS_URL + '/create', question);
  return result;
}

export async function deleteQuestion(id: number) {
  httpClient.delete(QUESTIONS_URL + '/delete/' + id);
}

export async function editQuestion(data: { id: number; question: TNewQuestion }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetQuestion>(`${QUESTIONS_URL}/update/${data.id}`, data.question);
  return result;
}

// file
// with axios
export async function addFileV2(file: File, config: {} = {}) {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const {
      data: { result },
    } = await httpClient.post(FILES_URL + '/create', formData, config);
    return result;
  } catch (error) {
    throw new Error('Upload failed!');
  }
}
export async function addFileV2WithData(formData: FormData, config: {} = {}) {
  try {
    const {
      data: { result },
    } = await httpClient.post(FILES_URL + '/create', formData, config);
    return result;
  } catch (error) {
    throw new Error('Upload failed!');
  }
}
// with fetch api
export async function addFile(file: File) {
  const auth = getAuth();
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API_URL}${FILES_URL}/create`, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${auth?.result.access.token}`,
    },
    body: formData,
  });
  return res.json();
}
// with xhr
export async function addFileV3(file: File) {
  const data = new FormData();
  data.append('file', file);

  const xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.addEventListener('readystatechange', function () {
    if (this.readyState === this.DONE) {
      console.log(this.responseText);
    }
  });

  xhr.open('POST', `${API_URL}${FILES_URL}/create`);
  xhr.setRequestHeader('Accept', 'application/json');
  const auth = getAuth();
  xhr.setRequestHeader('Authorization', `Bearer ${auth?.result.access.token}`);

  xhr.send(data);
}

// SETTINGS
export async function getSettings() {
  const {
    data: { result },
  } = await httpClient.get<IGetSettings>(SETTINGS_URL + '/list');
  return result;
}

// quiz types
export async function getQuizTypes() {
  const {
    data: { result },
  } = await httpClient.get<IGetQuizTypes>(QUIZ_TYPES_URL + '/list');
  return result;
}

// chapter
export async function getChapters() {
  const {
    data: { result },
  } = await httpClient.get<IGetChapters>(`${CHAPTERS_URL}/list`);

  return result;
}

export async function addChapter(chapter: INewChapter) {
  const {
    data: { result },
  } = await httpClient.post<IGetChapter>(CHAPTERS_URL + '/create', chapter);
  return result;
}

export async function deleteChapter(id: number) {
  httpClient.delete(`${CHAPTERS_URL}/delete/${id}`);
}

export async function editChapter(data: { id: number; chapter: INewChapter }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetChapter>(`${CHAPTERS_URL}/update/${data.id}`, data.chapter);
  return result;
}

// challenges
export async function getChallenges() {
  const {
    data: { result },
  } = await httpClient.get<IGetChallenges>(`${CHALLENGES_URL}/list`);

  return result;
}

export async function addChallenge(challenge: TNewChallenge) {
  const {
    data: { result },
  } = await httpClient.post<IGetChallenge>(CHALLENGES_URL + '/create', challenge);
  return result;
}

export async function deleteChallenge(id: number) {
  httpClient.delete(`${CHALLENGES_URL}/delete/${id}`);
}

export async function editChallenge(data: { id: number; challenge: TNewChallenge }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetChallenge>(`${CHALLENGES_URL}/update/${data.id}`, data.challenge);
  return result;
}
// challenge results
export async function getChallengeResults() {
  const {
    data: { result },
  } = await httpClient.get<IGetChallengeResults>(`${CHALLENGE_RESULTS_URL}/list`);

  return result;
}

export async function addChallengeResult(challengeResult: INewChallengeResult) {
  const {
    data: { result },
  } = await httpClient.post<IGetChallengeResult>(
    CHALLENGE_RESULTS_URL + '/create',
    challengeResult
  );
  return result;
}

export async function deleteChallengeResult(id: number) {
  httpClient.delete(`${CHALLENGE_RESULTS_URL}/delete/${id}`);
}

export async function editChallengeResult(data: { id: number; challenge: INewChallengeResult }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetChallengeResult>(
    `${CHALLENGE_RESULTS_URL}/update/${data.id}`,
    data.challenge
  );
  return result;
}

// categorry lessons
export async function getLessonCategoriesBySubjectId(SubjectId: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetLessonCategories>(`${CATEGORY_LESSONS_URL}/${SubjectId}/list`);
  return result;
}

export async function addLessonCategory(data: { subject_id: number; title: string }) {
  httpClient.post(`${CATEGORY_LESSONS_URL}/${data.subject_id}/create`, { title: data.title });
}

export async function editLessonCategory(data: {
  ids: { id: number; subjectId: number };
  title: string;
}) {
  const {
    ids: { id, subjectId },
    title,
  } = data;
  httpClient.patch(`${CATEGORY_LESSONS_URL}/${subjectId}/update/${id}`, { title });
}

export async function deleteLessonCategory(ids: { id: number; subjectId: number }) {
  const { id, subjectId } = ids;
  httpClient.delete(`${CATEGORY_LESSONS_URL}/${subjectId}/delete/${id}`);
}

// media lessons
export async function addLesson(data: INewLesson) {
  const {
    data: { result },
  } = await httpClient.post<IGetLesson>(LESSONS_URL + '/create', data);
  return result;
}

export async function getLessons() {
  const {
    data: { result },
  } = await httpClient.get<IGetLessons>(LESSONS_URL + '/list');
  return result;
}

export async function getLessonById(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetLesson>(`${LESSONS_URL} /show/${id}`);
  return result;
}

export async function updateLesson(newData: { id: number; data: INewLesson }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetLesson>(`${LESSONS_URL}/update/${newData.id}`, newData.data);
  return result;
}

export async function deleteLesson(id: number) {
  httpClient.delete(`${LESSONS_URL}/delete/${id}`);
}

// lesson sections
export async function addLessonSection(data: {
  lesson_id: number;
  newLessonSection: INEWLessonSection;
}) {
  const { lesson_id, newLessonSection } = data;
  const {
    data: { result },
  } = await httpClient.post<IGetLessonSection>(
    `${LESSON_SECTIONS_URL}/${lesson_id}/create`,
    newLessonSection
  );
  return result;
}

export async function getLessonSections(lesson_id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetLessonSections>(`${LESSON_SECTIONS_URL}/${lesson_id}/list`);
  return result;
}

export async function updateLessonSection(newData: {
  ids: { lesson_id: number; lesson_section_id: number };
  data: INEWLessonSection;
}) {
  const {
    data: { result },
  } = await httpClient.patch<IGetLessonSection>(
    `${LESSON_SECTIONS_URL}/${newData.ids.lesson_id}/update/${newData.ids.lesson_section_id}`,
    newData.data
  );
  return result;
}

export async function deleteLessonSection(ids: { lesson_id: number; lesson_section_id: number }) {
  httpClient.delete(`${LESSON_SECTIONS_URL}/${ids.lesson_id}/delete/${ids.lesson_section_id}`);
}

// mindmap
export async function addMindMap(mindMap: INewMindmap) {
  const {
    data: { result },
  } = await httpClient.post<IGetMindmap>(MINDMAP_URL + '/create', mindMap);
  return result;
}

export async function getMindMaps() {
  const {
    data: { result },
  } = await httpClient.get<IGetMindmaps>(`${MINDMAP_URL}/list`);

  return result;
}

export async function updateMindMap(newData: { id: number; data: INewMindmap }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetMindmap>(`${MINDMAP_URL}/update/${newData.id}`, newData.data);
  return result;
}

export async function deleteMindMap(id: number) {
  httpClient.delete(`${MINDMAP_URL}/delete/${id}`);
}

// lexiques
export async function getLexiques() {
  const {
    data: { result },
  } = await httpClient.get<IGetLexiques>(`${LEXIQUES_URL}/list`);

  return result;
}

export async function deleteLexique(id: number) {
  httpClient.delete(`${LEXIQUES_URL}/delete/${id}`);
}

export async function addLexique(lexique: INewLexique) {
  const {
    data: { result },
  } = await httpClient.post<IGetLexique>(`${LEXIQUES_URL}/create`, lexique);
  return result;
}

export async function updateLexique(newData: { id: number; data: INewLexique }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetLexique>(`${LEXIQUES_URL}/update/${newData.id}`, newData.data);
  return result;
}

// fiches
export async function getFiches() {
  const {
    data: { result },
  } = await httpClient.get<IGetIFiches>(`${FICHES_URL}/list`);

  return result;
}

export async function getFiche(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetIFiche>(`${FICHES_URL}/show/${id}`);

  return result;
}

export async function deleteFiche(id: number) {
  httpClient.delete(`${FICHES_URL}/delete/${id}`);
}

export async function addFiche(fiche: INewIFiche) {
  const {
    data: { result },
  } = await httpClient.post<IGetIFiche>(`${FICHES_URL}/create`, fiche);
  return result;
}

export async function updateFiche(newData: { id: number; data: INewIFiche }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetIFiche>(`${FICHES_URL}/update/${newData.id}`, newData.data);
  return result;
}

// avatars
export async function getAvatars() {
  const {
    data: { result },
  } = await httpClient.get<IGetIAvatars>(`${AVATARS_URL}/list`);

  return result;
}

export async function getAvatar(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetIAvatar>(`${AVATARS_URL}/show/${id}`);

  return result;
}

export async function deleteAvatar(id: number) {
  httpClient.delete(`${AVATARS_URL}/delete/${id}`);
}

export async function addAvatar(lexique: INewAvatar) {
  const {
    data: { result },
  } = await httpClient.post<IGetIAvatar>(`${AVATARS_URL}/create`, lexique);
  return result;
}

export async function updateAvatar(newData: { id: number; data: INewAvatar }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetIAvatar>(`${AVATARS_URL}/update/${newData.id}`, newData.data);
  return result;
}

// accesories
export async function getAccesories() {
  const {
    data: { result },
  } = await httpClient.get<IGetIAccesories>(`${ACCESSORIES_URL}/list`);

  return result;
}

export async function getAccesory(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetIAccesory>(`${ACCESSORIES_URL}/show/${id}`);

  return result;
}

export async function deleteAccesory(id: number) {
  httpClient.delete(`${ACCESSORIES_URL}/delete/${id}`);
}

export async function addAccesory(lexique: INewAccesory) {
  const {
    data: { result },
  } = await httpClient.post<IGetIAccesory>(`${ACCESSORIES_URL}/create`, lexique);
  return result;
}

export async function updateAccesory(newData: { id: number; data: INewAccesory }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetIAccesory>(
    `${ACCESSORIES_URL}/update/${newData.id}`,
    newData.data
  );
  return result;
}

// specialObjects
export async function getSpecialObjects() {
  const {
    data: { result },
  } = await httpClient.get<IGetSpecialObjects>(`${SPECIAL_OBJECTS_URL}/list`);

  return result;
}

export async function getSpecialObject(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetSpecialObject>(`${SPECIAL_OBJECTS_URL}/show/${id}`);

  return result;
}

export async function deleteSpecialObject(id: number) {
  httpClient.delete(`${SPECIAL_OBJECTS_URL}/delete/${id}`);
}

export async function addSpecialObject(lexique: INewSpecialObject) {
  const {
    data: { result },
  } = await httpClient.post<IGetSpecialObject>(`${SPECIAL_OBJECTS_URL}/create`, lexique);
  return result;
}

export async function updateSpecialObject(newData: { id: number; data: INewSpecialObject }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetSpecialObject>(
    `${SPECIAL_OBJECTS_URL}/update/${newData.id}`,
    newData.data
  );
  return result;
}

export async function getSpecialObjectsTypes() {
  const {
    data: { result },
  } = await httpClient.get<IGetSpecialObjectTypes>(`${SPECIAL_OBJECTS_URL}/get-types`);
  return result;
}

// badges
export async function getBadges() {
  const {
    data: { result },
  } = await httpClient.get<IGetBadges>(`${BADGES_URL}/list`);

  return result;
}

export async function getBadge(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetBadge>(`${BADGES_URL}/show/${id}`);

  return result;
}

export async function deleteBadge(id: number) {
  httpClient.delete(`${BADGES_URL}/delete/${id}`);
}

export async function addBadge(lexique: INewBadge) {
  const {
    data: { result },
  } = await httpClient.post<IGetBadge>(`${BADGES_URL}/create`, lexique);
  return result;
}

export async function updateBadge(newData: { id: number; data: INewBadge }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetSpecialObject>(`${BADGES_URL}/update/${newData.id}`, newData.data);
  return result;
}

export async function getBadgeTypes() {
  const {
    data: { result },
  } = await httpClient.get<IGetBadgeTypes>(`${BADGES_URL}/get-types`);
  return result;
}

// objects
export async function deleteObject(object: TObject) {
  const { id, objectType } = object;
  if (objectType === ObjectTypes.avatar) {
    deleteAvatar(id);
  } else if (objectType === ObjectTypes.accessory) {
    deleteAccesory(id);
  } else if (objectType === ObjectTypes.special_object) {
    deleteSpecialObject(id);
  } else {
    deleteBadge(id);
  }
}

export async function addObject(data: TNewObject) {
  const { objectType, ...rest } = data;
  let result;
  if (objectType === ObjectTypes.avatar) {
    result = await addAvatar(rest as INewAvatar);
  } else if (objectType === ObjectTypes.accessory) {
    result = await addAccesory(rest as INewAccesory);
  } else if (objectType === ObjectTypes.badge) {
    result = await addBadge(rest as INewBadge);
  } else {
    result = await addSpecialObject(rest as INewSpecialObject);
  }
  return result;
}

export async function editObject(data: TNewObject & { id: number }) {
  const { objectType, id, ...rest } = data;
  let result;
  if (objectType === ObjectTypes.avatar) {
    result = await updateAvatar({ id, data: rest as INewAvatar });
  } else if (objectType === ObjectTypes.accessory) {
    result = await updateAccesory({ id, data: rest as INewAccesory });
  } else if (objectType === ObjectTypes.badge) {
    result = await updateBadge({ id, data: rest as INewBadge });
  } else {
    result = await updateSpecialObject({ id, data: rest as INewSpecialObject });
  }
  return result;
}

// subscription
export async function getSubscriptions() {
  const {
    data: { result },
  } = await httpClient.get<IGetSubscriptions>(`${SUBSCRIPTIONS_URL}/list`);

  return result;
}

export async function getSubscription(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetSubscription>(`${SUBSCRIPTIONS_URL}/show/${id}`);

  return result;
}

export async function deleteSubscription(id: number) {
  httpClient.delete(`${SUBSCRIPTIONS_URL}/delete/${id}`);
}

export async function addSubscription(subscription: INewSubscription) {
  const {
    data: { result },
  } = await httpClient.post<IGetSubscription>(`${SUBSCRIPTIONS_URL}/create`, subscription);
  return result;
}

export async function updateSubscription(newData: { id: number; data: INewSubscription }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetSubscription>(
    `${SUBSCRIPTIONS_URL}/update/${newData.id}`,
    newData.data
  );
  return result;
}

// subjects
export async function getSubjects(id?:number|string) {
    const {
      data: {result},
    } = await httpClient.get<IGetSubjects>(SUBJECTS_URL(id));

    return result?.data;
}

export async function updateSubjectStatus(newData: { id: number; status: NewSubjectStatus }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetSubject>(UPDATE_SUBJECT_STATUS(newData.id), newData.status);

  return result;
}

// FAQs
export async function getFAQs() {
  const {
    data: { result },
  } = await httpClient.get<IGetFAQs>(`${FAQ_URL}/list`);

  return result;
}

export async function getFAQ(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetFAQ>(`${FAQ_URL}/show/${id}`);

  return result;
}

export async function deleteFAQ(id: number) {
  httpClient.delete(`${FAQ_URL}/delete/${id}`);
}

export async function addFAQ(faq: INewFAQ) {
  const {
    data: { result },
  } = await httpClient.post<IGetFAQ>(`${FAQ_URL}/create`, faq);
  return result;
}

export async function updateFAQ(newData: { id: number; data: INewFAQ }) {
  const {
    data: { result },
  } = await httpClient.patch<IGetFAQ>(`${FAQ_URL}/update/${newData.id}`, newData.data);
  return result;
}

// ADMINS
export async function getAdmins() {
  const {
    data: { result },
  } = await httpClient.get<IGetAdmins>(`${ADMIN_URL}/list`);

  return result;
}

export async function getAdmin(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetAdmin>(`${ADMIN_URL}/show/${id}`);

  return result;
}

export async function deleteAdmin(id: number) {
  httpClient.delete(`${ADMIN_URL}/delete/${id}`);
}

export async function addAdmin(admin: INewAdmin) {
  const {
    data: { result },
  } = await httpClient.post<IGetAdmin>(`${ADMIN_URL}/create`, admin);
  return result;
}

export async function updateAdmin(newData: INewAdmin & { id: number }) {
  const { id, ...rest } = newData;
  const {
    data: { result },
  } = await httpClient.patch<IGetAdmin>(`${ADMIN_URL}/update/${id}`, { ...rest });
  return result;
}

// users
export async function getUsers(page:number,search:string) {
  const {
    data: { result },
  } = await httpClient.get<IGetUsers>(`${USER_URL}/list?page=${page}${search ? '&search=' + search : ''}`);

  return result;
}

export async function getUser(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetUsers>(`${USER_URL}/list/${id}`);

  return result;
}

export async function reviewQuestion(data: { id: number; note: string }) {
  const { id, ...rest } = data;
  const {
    data: { result },
  } = await httpClient.patch<IGetUser>(`${USER_URL}/update/${id}`, { ...rest });

  return result;
}

export async function getUserSubscription(id: number) {
  const {
    data: { result },
  } = await httpClient.get<IGetUserSubscriptions>(`${USER_URL}/${id}/subscriptions`);

  return result;
}
// reviews
export async function getReviews(page:number,search:string) {
  const {
    data: { result },
  } = await httpClient.get<IGetReviews>(`${REVIEW_URL}/review?page=${page}${search ? '&search=' + search : ''}`);

  return result;
}
export async function deleteReview(id: number) {
  httpClient.delete(`${REVIEW_URL}/review/${id}`);
}
// Question Report
export async function getQuestionReport(page:number,search:string,filters: {
  'filters[status]'?: string| null,
  'filters[severity]'?: string| null,
}) {
  const {
    data: { result },
  } = await httpClient.get<IGetQuestionReport>(`${QUESTION_REPORT_URL}/aggregate?page=${page}${search ? '&search=' + search : ''}${filters['filters[severity]'] ? '&filters[severity]=' + filters['filters[severity]'] : ''}${filters['filters[status]'] ? '&filters[status]=' + filters['filters[status]'] : ''}`);

  return result;
}
export async function reviewQuestionReport(data: { id: number}) {
  const { id, ...rest } = data;
  const {
    data: { result },
  } = await httpClient.post<any>(`${QUESTION_REPORT_URL}/aggregate/${id}/review`, { ...rest });

  return result;
}
// UPLOAD CENTER
export async function uploadQuestions(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('main_quiz_type', 'les-quiz');

  const { data } = await httpClient.post<any>(UPLOAD_CENTER_URL, formData);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function uploadMindmaps(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await httpClient.post<any>(UPLOAD_CENTER_URL + '/mind-map', formData);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

// about us
export async function showAbout() {
  const {
    data: { result },
  } = await httpClient.get<any>(`${ABOUT_URL}/show`);

  return result;
}

export async function updateAbout(value: string) {
  const {
    data: { result },
  } = await httpClient.patch<any>(`${ABOUT_URL}/update`, { value });
  return result;
}

export async function getGrades() {
  const {
    data: { result },
  } = await httpClient.get<IGetIGrades>(GRADES_URL);

  return result;
}

export async function postCreateSubject(reqData: FormData, gradeId: string) {
  const { data } = await httpClient.post<any>(POST_CREATE_SUBJECT(gradeId), reqData);
  return data.result;
}

export async function deleteSubject(gId?:number|string, sId?:number|string) {
  httpClient.delete(DELETE_SUBJECT(gId, sId));
}

export async function updateGrade(id:string | number, body:IPutGrade) {
  const {
    data: { result },
  } = await httpClient.put<any>(UPDATE_GRADE(id), body);
  return result;
}

export async function putCreateSubject(reqData: FormData, gradeId: string, subjectId: string) {
  const { data } = await httpClient.post<any>(PUT_CREATE_SUBJECT(gradeId,subjectId), reqData);
  return data.result;
}

export async function getSubjectMenus(id:number){
  const {
    data: { result },
  } = await httpClient.get<IGetISubjectMenus>(SUBJECT_MENUS(id));

  return result;
}

export async function putSubjectMenus(id:number,mId:number, reqData:FormData){
  const { data } = await httpClient.post<any>(UPDATE_SUBJECT_MENUS(id,mId),reqData);
  return data;
}

export async function getActKeys(ActKeyQueries:ActKeyQueriesTypes){
  const {data: { result }} = await httpClient.get<IGetActKeys>(GET_ACT_KEYS, {params: ActKeyQueries})
  return result
}

export async function postCreateActKey(reqData: IActKeyBody) {
  const { data } = await httpClient.post<any>(POST_CREATE_ACT_KEY, reqData);
  return data.result;
}

export async function putAssignToUser(id:string | number, body:IPutAssignToUser) {
  const {
    data: { result },
  } = await httpClient.put<any>(ASSIGN_TO_USER(id), body);
  return result;
}

export async function getAllUsers(AllUsersQueries:AllUsersQueriesTypes){
  const {data: { result }} = await httpClient.get<IGetAllUsers>(GET_ALL_USERS, {params: AllUsersQueries})
  return result
}

export async function getAggregateReport(id:string){
  const {data: { result }} = await httpClient.get<aggregateReportResponse>(GET_AGG_REPORTS(id))
  return result
}

export async function getUserMetrics(userMetricParams:userMetricParamsType){
  const {data: { result }} = await httpClient.get<IGetUserMetrics>(USER_METRICS, {params: userMetricParams})
  return result
}

export async function getUserPopularity(userMetricParams:userContentsParamsType){
  const {data: { result }} = await httpClient.get<IGetUserContent>(USER_POPULARITY, {params: userMetricParams})
  return result
}

export async function getUserActivity(userMetricParams:userActivitiesParamsType){
  const {data: { result }} = await httpClient.get<IGetUserActivity>(USER_ACTIVITY, {params: userMetricParams})
  return result
}

export async function getAvatarChange() {
  const {data} = await httpClient.get<IGetAvatarChange>(AVATAR_CHANGE)
  return data
}

export async function getFriendDuel() {
  const {data} = await httpClient.get<IGetAvatarChange>(FRIEND_DUEL)
  return data
}

export async function getRandomDuel() {
  const {data} = await httpClient.get<IGetAvatarChange>(RANDOM_DUEL)
  return data
}

export async function getKeysProgress() {
  const {data} = await httpClient.get<IGetKeysProgress>(KEYS_PROGRESS)
  return data
}

export async function getLeveUp() {
  const {data:{result}} = await httpClient.get<IGetLevelUp>(LEVEL_UP)
  return result
}

export async function postAvatarAudioChange(file: FormData) {
  const { data } = await httpClient.post<any>(AVATAR_CHANGE_AUDIO , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postAvatarBackgroundChange(file: FormData) {
  const { data } = await httpClient.post<any>(AVATAR_CHANGE_BACKGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postAvatarForegroundChange(file: FormData) {
  const { data } = await httpClient.post<any>(AVATAR_CHANGE_FOREGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postAvatarChange(file: FormData) {
  const { data } = await httpClient.post<any>(POST_AVATAR_CHANGE , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postFriendDuelAvatar(file: FormData) {
  const { data } = await httpClient.post<any>(POST_FRIEND_DUEL_AVATAR , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postFriendDuelAudio(file: FormData) {
  const { data } = await httpClient.post<any>(POST_FRIEND_DUEL_AUDIO , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postFriendDuelBackground(file: FormData) {
  const { data } = await httpClient.post<any>(POST_FRIEND_DUEL_BACKGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postFriendDuelForeground(file: FormData) {
  const { data } = await httpClient.post<any>(POST_FRIEND_DUEL_FOREGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postRandomDuelAvatar(file: FormData) {
  const { data } = await httpClient.post<any>(POST_RANDOM_DUEL_AVATAR , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postRandomDuelAudio(file: FormData) {
  const { data } = await httpClient.post<any>(POST_RANDOM_DUEL_AUDIO , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postRandomDuelBackground(file: FormData) {
  const { data } = await httpClient.post<any>(POST_RANDOM_DUEL_BACKGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postRandomDuelForeground(file: FormData) {
  const { data } = await httpClient.post<any>(POST_RANDOM_DUEL_FOREGROUND , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postKeyProgress(file: FormData) {
  const { data } = await httpClient.post<any>(POST_KEY_PROGRESS , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postLevelUpAvatar(file: FormData) {
  const { data } = await httpClient.post<any>(POST_LEVEL_UP_AVATAR , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}
export async function postStarLevelUpAnimation(file: FormData) {
  const { data } = await httpClient.post<any>(POST_LEVEL_UP_STARS , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}

export async function postLevelUpSound(file: FormData) {
  const { data } = await httpClient.post<any>(POST_LEVEL_UP_SOUNDS , file);
  if (data && data.result) {
    return data.result;
  } else throw new Error('uploaded file is invalid');
}